export const getInitialState = () => ({
  data: {
    id: '',
    visit: '',
    status: '',
    patient: {
      cip: '',
      cpf: '',
      name: '',
      birthDate: '',
      sex: '',
      email: '',
    },
    medicalOrders: [
      {
        exams: [],
      },
    ],
    questions: [],
    payments: [
      {
        clientId: '',
        clientName: '',
        status: '',
        value: '',
        details: {},
      },
    ],
    unitId: '',
    source: {
      origin: '',
      externalId: '',
    },
    checkInDone: false,
    backOfficeDone: false,
    paymentMethod: null,
  },
});

export const state = getInitialState();
